import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "../../common/services/auth.service";
import { SwitchLanguageService } from "../../common/services/switch-language.service";

@Component({
    selector: "app-header-one",
    templateUrl: "./header-one.component.html",
    styleUrls: ["./header-one.component.scss"],
})
export class HeaderOneComponent implements OnInit {
    currentLang: string = "";
    isAuthenticated: boolean;

    constructor(
        private switchLang: SwitchLanguageService,
        public translate: TranslateService,
        private authService: AuthService
    ) {
        this.isAuthenticated = this.authService.isLoggedIn();
    }

    ngOnInit(): void {
        this.currentLang = this.switchLang.getCurrentLang();
    }

    classApplied = false;
    toggleClass() {
        this.classApplied = !this.classApplied;
    }

    changeLanguage(lang) {
        this.switchLang.ChangeLanguage(lang);
        this.currentLang = this.switchLang.getCurrentLang();
    }

    logout() {
        this.authService.logout();
    }
}
